import { useEffect, useCallback } from 'react'

const PIXEL_ID = '1425901482655593'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

// Initialize pixel immediately (outside of React)
function initPixel() {
  if (typeof window === 'undefined') return

  // If already initialized, skip
  if (window.fbq) return

  // Standard Meta Pixel base code
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
}

// Initialize on module load
initPixel()

export function useMetaPixel() {
  useEffect(() => {
    // Ensure pixel is initialized
    initPixel()

    // Track PageView
    if (window.fbq) {
      window.fbq('track', 'PageView')
    }
  }, [])

  const trackInitiateCheckout = useCallback(
    (value: number, contentName: string) => {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'InitiateCheckout', {
          value: value,
          currency: 'USD',
          content_name: contentName,
          content_type: 'product',
        })
      }
    },
    [],
  )

  return { trackInitiateCheckout }
}
